const article = {
    id: 'planning-bay-assign',
    title: 'Assign planning groups to a bay',
    summary: 'Select pendency groups in Planning and assign them to a bay from the right-click menu.',
    publishedAt: '2026-08-25',
    tags: ['planning', 'bay'],
    sections: [
        {
            type: 'paragraph',
            text: 'Planning groups SKUs into pendency groups. You can select one or many groups and assign them to a bay. The menu shows how full each bay already is.',
        },
        { type: 'heading', text: 'When to use' },
        {
            type: 'paragraph',
            text: 'Use it when you are building the day’s bay plan and want to move several groups at once.',
        },
        { type: 'heading', text: 'How to use' },
        {
            type: 'steps',
            items: [
                'Open Planning and the pendency view for the shoot.',
                'Select the groups you want to move. Shift-click selects a range.',
                'Right-click a selected group and choose Assign to bay.',
                'Pick the bay. The label shows assigned count against capacity.',
            ],
        },
    ],
};

export default article;
